import React from 'react';
import SearchFilters from 'src/components/AnageImoveis/SearchFilters';

const SearchFiltersDrawer = ({ onClose }) => (
  <>
    <div className="filters-section-overlay" />
    <SearchFilters variant="drawer" onClose={onClose} />
  </>
);

export default SearchFiltersDrawer;
